"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filename = exports.pseudoRandom = exports.dbPath = exports.clearHttp = exports.boolValuesObj = exports.isUndefinedOrNull = exports.isUndefined = exports.rslv = exports.unFlat = exports.flat = exports.mapIndexed = void 0;
const tslib_1 = require("tslib");
const is_primitive_1 = tslib_1.__importDefault(require("is-primitive"));
const lodash_1 = require("lodash");
const fast_safe_stringify_1 = tslib_1.__importDefault(require("fast-safe-stringify"));
const flat_1 = require("flat");
const Res_1 = require("../logic/Res");
const path_1 = require("path");
function mapIndexed(rawIndexed, mapper) {
    if (rawIndexed == null) {
        return null;
    }
    if (is_primitive_1.default(rawIndexed)) {
        throw new Error(`Got primitive type. Expecting object. Value: ${fast_safe_stringify_1.default(rawIndexed)}`);
    }
    const res = {};
    if (lodash_1.isObject(rawIndexed)) {
        for (const e of Object.entries(rawIndexed)) {
            res[e[0]] = mapper(e[1], e[0]);
        }
    }
    return res;
}
exports.mapIndexed = mapIndexed;
function flat(target) {
    return flat_1.flatten(target, { delimiter: "/", safe: true });
}
exports.flat = flat;
function unFlat(flatObject) {
    return flat_1.unflatten(flatObject, { delimiter: "/", safe: true });
}
exports.unFlat = unFlat;
function rslv(promise) {
    return promise.then((data) => Res_1.Res.ok(data)).catch((error) => Promise.resolve(Res_1.Res.fail(error)));
}
exports.rslv = rslv;
function isUndefined(v) {
    return typeof v === "undefined";
}
exports.isUndefined = isUndefined;
function isUndefinedOrNull(v) {
    return typeof v === "undefined" || v == null;
}
exports.isUndefinedOrNull = isUndefinedOrNull;
function boolValuesObj(obj) {
    if (!lodash_1.isObject(obj))
        return {};
    return Object.keys(obj).reduce((res, key) => {
        res[key] = true;
        return res;
    }, {});
}
exports.boolValuesObj = boolValuesObj;
function clearHttp(url) {
    if (url.startsWith("https://"))
        return url.slice(8, url.length);
    if (url.startsWith("http://"))
        return url.slice(7, url.length);
    return url;
}
exports.clearHttp = clearHttp;
/*
Expects that the dbRefObject.toString() will return full path e.g: https://akular-devel.firebaseio.com/path/to/object
 */
function dbPath(dbRefObject) {
    return dbRefObject.toString().split("/").slice(3);
}
exports.dbPath = dbPath;
function pseudoRandom(pow) {
    return Math.round(Math.random() * Math.pow(10, pow)).toString(36);
}
exports.pseudoRandom = pseudoRandom;
function filename(fullPath) {
    const bn = path_1.basename(fullPath);
    return bn.substring(0, bn.lastIndexOf("."));
}
exports.filename = filename;
//# sourceMappingURL=utils.js.map